
        import 'Documents.5652663.css-module'
        export default {"name":"name_Documents_5652663","dateIssued":"dateIssued_Documents_5652663","view":"view_Documents_5652663"}
    